var constants = {
  

  // MOCK_VERSION: '0.3.45.Web',
  // FIREBASE_API_URL: 'https://us-central1-retina-47daf.cloudfunctions.net',
  // ENVIRONMENT: 'Production',
  // FIREBASE_CONFIG:{
  //   apiKey: "AIzaSyChjzhnymSTLgx4qM9WO9FWiwTdWQUjV_I",
  //   authDomain: "retina-47daf.firebaseapp.com",
  //   databaseURL: "https://retina-47daf.firebaseio.com",
  //   projectId: "retina-47daf",
  //   storageBucket: "retina-47daf.appspot.com",
  //   messagingSenderId: "89955891141"
  // },

  PHOTO_SETTINGS: {
    quality: 50,
    encodingType: 0,
    targetWidth: 1024,
    targetHeight: 1024,
    correctOrientation: true,
    allowEdit: false
  },

  GALLERY_SETTINGS: {
    quality: 20,
    destinationType: 0,
    sourceType: 0,
    encodingType: 0,
    targetWidth: 1024,
    targetHeight: 1024,
    correctOrientation: true,
    allowEdit: false
  },

  GPS_SETTINGS: {
    maximumAge: 15000,
    timeout: 15000,
    enableHighAccuracy: true
  }, 


};

var Global = {
  client_id: 'navigator-test',
  grant_type: 'password',
  profile: null,
  access_token: null,
  access_token_name: null,
  months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  provinces: [
    { short: "AB", name: "Alberta", country: "CA" , color: "blue"},
    { short: "BC", name: "British Columbia", country: "CA", color: "yellow" },
    { short: "MB", name: "Manitoba", country: "CA", color: "orange" },
    { short: "NB", name: "New Brunswick", country: "CA", color: "purple" },
    {
      short: "NL",
      name: "Newfoundland and Labrador",
      country: "CA",
      alt: ["Newfoundland", "Labrador"], color: "pink"
    },
    { short: "NS", name: "Nova Scotia", country: "CA", color: "grey" },
    { short: "NU", name: "Nunavut", country: "CA", color: "black" },
    { short: "NT", name: "Northwest Territories", country: "CA", color: "white" },
    { short: "ON", name: "Ontario", country: "CA", color: "red" },
    { short: "PE", name: "Prince Edward Island", country: "CA", color: "silver" },
    { short: "QC", name: "Quebec", country: "CA", color: "brown" },
    { short: "SK", name: "Saskatchewan", country: "CA", color: "green" },
    { short: "YT", name: "Yukon", country: "CA", color: "indigo" }
  ],
};

export let AppConfig = {
  //getFormmatedDate: getFormattedDateOf,
  Global: Global,
  constants: constants
}





// WEBPACK FOOTER //
// ./src/providers/config.ts